export const DEFAULT_SHIPPING_FEE = {
  Dakahlia: 30,
  Damietta: 75,
  Gharbia: 80,
  'Kafr El Sheikh': 80,
  Sharqia: 85,
  Monufia: 85,
  Beheira: 90,
  'Port Said': 90,
  Qalyubia: 90,
  Cairo: 95,
  Alexandria: 95,
  Ismailia: 95,
  Giza: 100,
  Suez: 100,
  Fayoum: 105,
  'Beni Suef': 110,
  Minya: 110,
  Matrouh: 115,
  'Red Sea': 115,
  Asyut: 115,
  Sohag: 115,
  Qena: 120,
  Luxor: 120,
  Aswan: 120,
  'New Valley': 120,
  'North Sinai': 120,
  'South Sinai': 120,
};
